import { Route, Switch, useLocation } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import PropTypes from 'prop-types';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { addPropsToComponent } from '@yooink/youtils/es/AddPropsToComponent';
import { useMemo } from 'react';
import { YoOrder } from '../../Components/Icons/YoOrder';
import { useHistory } from 'react-router';
import { useSpotlightActions } from '../../AppSpotlight';
import { GiCakeSlice } from 'react-icons/gi';

MenuManager.RegisterItem({
	key: 'Orders',
	path: '/orders',
	icon: <YoOrder />,
	name: 'Заказы',
	position: 2,
	badgeProps: {
		color: 'info',
		title: 'За 24 часа / За 7 дней'
	}
});

function OrdersRoute (props) {
	const location = useLocation();
	const basePath = props.path || '/orders';
	const getPath = (path = '') => `${basePath}${path}`;

	const history = useHistory();
	useSpotlightActions([{
		id: 'orders.page',
		title: 'Заказы',
		onTrigger: () => history.push(getPath())
	}]);

	const List = useLoadComponent(() => import('./List').then((m) => m.ListOrders), {
		basePath
	});

	const AmoIntegrationErrorList = useMemo(() => addPropsToComponent({ integrationError: 'amo' }, List), []);
	const MsIntegrationErrorList = useMemo(() => addPropsToComponent({ integrationError: 'ms' }, List), []);
	const TkIntegrationErrorList = useMemo(() => addPropsToComponent({ integrationError: 'tk' }, List), []);

	const View = useLoadComponent(() => import('./View').then((mod) => mod.OrderViewController), {
		basePath
	});

	const Edit = useLoadComponent(() => import('./Edit/Edit').then((mod) => mod.Edit), {
		basePath
	});

	return (
		<>
			<Route
				exact={!location.pathname.includes(getPath('/view'))}
				path={getPath()}
				component={List}
			/>
			<Route
				exact={!location.pathname.includes(getPath('/view'))}
				path={getPath('/integrationError/amo')}
				component={AmoIntegrationErrorList}
			/>
			<Route
				exact={!location.pathname.includes(getPath('/view'))}
				path={getPath('/integrationError/ms')}
				component={MsIntegrationErrorList}
			/>
			<Route
				exact={!location.pathname.includes(getPath('/view'))}
				path={getPath('/integrationError/tk')}
				component={TkIntegrationErrorList}
			/>
			<Switch>

				<Route
					exact
					path={getPath('/view/:id')}
					component={View}
				/>
				<Route
					exact
					path={getPath('/edit/:id')}
					component={Edit}
				/>
			</Switch>
		</>
	);
}

OrdersRoute.propTypes = {
	path: PropTypes.string
};

export { OrdersRoute };
